import type { LightBehavior } from "../types";

export interface LightAnimationSample {
  radiusScale: number;
  intensityScale: number;
}

const seedFor = (id: string) => {
  let hash = 2166136261;
  for (let index = 0; index < id.length; index += 1) hash = Math.imul(hash ^ id.charCodeAt(index), 16777619);
  return (hash >>> 0) / 0xffffffff * Math.PI * 2;
};

/** Smooth, deterministic flame motion with no abrupt on/off flicker. */
export function lightAnimationSample(behavior: LightBehavior | undefined, id: string, elapsedMs: number): LightAnimationSample {
  if (behavior !== "flame") return { radiusScale: 1, intensityScale: 1 };
  const time = Math.max(0, elapsedMs) / 1000; const seed = seedFor(id);
  const wave = Math.sin(time * 2.15 + seed) * 0.50
    + Math.sin(time * 4.55 + seed * 1.73) * 0.30
    + Math.sin(time * 0.92 + seed * 2.31) * 0.20;
  const amount = Math.max(0, Math.min(1, (wave + 1) / 2));
  return { radiusScale: 0.94 + amount * 0.06, intensityScale: 0.82 + amount * 0.18 };
}
